import { Injectable, inject } from '@angular/core'
import { ApiClient } from '@ftr/api-shared'
import { Region } from '@ftr/contracts/type/court'
import { Uuid } from '@ftr/contracts/type/shared'
import { Observable } from 'rxjs'
import { RegionalApiClientFactory } from './regional-api-client.factory'

@Injectable({
  providedIn: 'root',
})
export class RegionalApiClientSetupService {
  private readonly regionalApiClientFactory = inject(RegionalApiClientFactory)

  regionalApiPath: string
  readonly regionalApiClientMap = new Map<string, Observable<ApiClient>>()
  readonly regionalApiClientByRegionMap = new Map<string, ApiClient>()

  regionalApiClient(path: string, courtSystemId: Uuid): Observable<ApiClient> {
    const uniqueKey = `${path}-${courtSystemId}`
    if (!this.regionalApiClientMap.has(uniqueKey)) {
      // Note on testing: regionalApiClientFactory.build needs to return from([apiClient.object]),
      // not of(apiClient.object)
      this.regionalApiClientMap.set(uniqueKey, this.regionalApiClientFactory.buildForCourt(path, courtSystemId))
    }
    return this.regionalApiClientMap.get(uniqueKey)!
  }

  /**
   * Build a regional ApiClient when the caller already knows the region. Avoids
   * hitting the authenticated `/court-system/:id` endpoint via CourtSystemRegionCache,
   * which is essential for unauthenticated public flows.
   */
  regionalApiClientForRegion(path: string, region: Region): ApiClient {
    const uniqueKey = `${path}-${region}`
    if (!this.regionalApiClientByRegionMap.has(uniqueKey)) {
      this.regionalApiClientByRegionMap.set(uniqueKey, this.regionalApiClientFactory.buildForRegion(path, region))
    }
    return this.regionalApiClientByRegionMap.get(uniqueKey)!
  }
}
